// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TGetHrisFieldsRequestPayload,
  TGetHrisFieldsResponsePayload,
  TGetHrisTagDocumentCountsRequestPayload,
  TGetHrisTagDocumentCountsResponsePayload,
  TGetHrisTaggingRequestPayload,
  TGetHrisTaggingResponsePayload,
  TPreviewHrisTagRulesRequestPayload,
  TPreviewHrisTagRulesResponsePayload,
  TSaveHrisTagRequestPayload,
  TSaveHrisTagResponsePayload,
  TSetHrisTagRulesRequestPayload,
  TSetHrisTagRulesResponsePayload,
} from './hris-tagging.types.ts';

export const createHrisTaggingApi = (transport: TApiTransport) => ({
  /** Lists the HR data fields and their values for the rule dropdowns */
  getHrisFields: (
    payload: TGetHrisFieldsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TGetHrisFieldsRequestPayload, TGetHrisFieldsResponsePayload>(
      '/get_hris_fields',
      payload,
      options,
    ),

  /** Counts the documents using each value of each project tag */
  getHrisTagDocumentCounts: (
    payload: TGetHrisTagDocumentCountsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetHrisTagDocumentCountsRequestPayload,
      TGetHrisTagDocumentCountsResponsePayload
    >('/get_hris_tag_document_counts', payload, options),

  /** Lists the project tags with their rules for the HRIS Tagging page */
  getHrisTagging: (
    payload: TGetHrisTaggingRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetHrisTaggingRequestPayload,
      TGetHrisTaggingResponsePayload
    >('/get_hris_tagging', payload, options),

  /** Counts the people each unsaved rule of one project tag would give a value to */
  previewHrisTagRules: (
    payload: TPreviewHrisTagRulesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TPreviewHrisTagRulesRequestPayload,
      TPreviewHrisTagRulesResponsePayload
    >('/preview_hris_tag_rules', payload, options),

  /** Creates or edits a project tag from the HRIS Tagging page */
  saveHrisTag: (
    payload: TSaveHrisTagRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TSaveHrisTagRequestPayload, TSaveHrisTagResponsePayload>(
      '/save_hris_tag',
      payload,
      options,
    ),

  /** Saves the rules of one project tag */
  setHrisTagRules: (
    payload: TSetHrisTagRulesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TSetHrisTagRulesRequestPayload,
      TSetHrisTagRulesResponsePayload
    >('/set_hris_tag_rules', payload, options),
});
